import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './AffichageCodeJour.css';

const AffichageCodeJour = () => {
  const [code, setCode] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadCodeJour();
  }, []);

  const loadCodeJour = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await api.pointage.codeJour();
      setCode(response.code);
    } catch (err) {
      if (err.response?.status === 404) {
        setError('Aucun code généré pour aujourd\'hui');
      } else {
        setError('Erreur lors du chargement du code');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="affichage-code-jour">
      <div className="code-jour-header">
        <div className="code-jour-icon">🔑</div>
        <div>
          <h3 className="code-jour-title">Code de Validation du Jour</h3>
          <p className="code-jour-subtitle">Code à communiquer aux employés pour pointer</p>
        </div>
      </div>

      <div className="code-jour-body">
        {loading && (
          <div className="code-jour-loading">
            <div className="spinner"></div>
            <span>Chargement...</span>
          </div>
        )}

        {!loading && error && (
          <div className="code-jour-error">
            <span className="error-icon">⚠️</span>
            <span>{error}</span>
          </div>
        )}

        {!loading && !error && code && (
          <div className="code-jour-display">
            <div className="code-value">{code}</div>
            <div className="code-actions">
              <button 
                onClick={() => navigator.clipboard.writeText(code)}
                className="btn-copy"
                title="Copier le code"
              >
                📋 Copier
              </button>
              <button 
                onClick={loadCodeJour}
                className="btn-refresh"
                title="Actualiser"
              >
                🔄 Actualiser
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="code-jour-info">
        <small>
          ℹ️ Ce code est valable pour aujourd'hui uniquement. 
          Les employés doivent l'utiliser pour valider leur présence.
        </small>
      </div>
    </div>
  );
};

export default AffichageCodeJour;
